import React, { useEffect, useRef, useState } from "react";
import { IoPersonCircleSharp } from "react-icons/io5";
import ReactToPrint from "react-to-print";
import { useSelector } from "react-redux";
import HeaderContainer from "../../components/UI/‌Header/HeaderContainer";

import Colors from "../../constant/Colors";
import { IDNumberGenerator } from "../../customFunction/IDGenerator";
import { handleLoading } from "../../store/actions/loadingAction";
import { createCourse } from "../../store/actions/coursesAction";
import numeral from "numeral";
import dayjs from "dayjs";
import { convertCurrency } from "../../store/actions/dollarPricesAction";
import { t } from "i18next";
import i18n from "../../i18n";
import useSWR from "swr";
import { fetcher, Loading } from "../../components/UI/TableView/ShowPaginationData";
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import CoursePriceCalculationModal from "../../components/Course/CoursePriceCalculationModal";

//!TYPES 0 normal 1 vip

const smalltalk = require("smalltalk");

function RequestCourseScreen() {
  const currentCenterId = JSON.parse(localStorage.getItem("centerId")).centerId;

  const { data: coaches, isLoading, error } = useSWR('/admins?type=3&activeEmployee=true&centerId=' + currentCenterId, fetcher)
  const { data: CourseTypes, isLoadingg, errorr } = useSWR('/course-types?centerId=' + currentCenterId, fetcher)
  const language = i18n.language
  const currentUser = useSelector(state => state.users.currentUser)
  const currentAdmin = useSelector((state) => state.authentication.user);
  const [selectedCourse, setSelectedCourse] = useState(1);
  const [currentCoach, setCurrentCoach] = useState(false);


  if (isLoading || isLoadingg) return <Loading />
  if (error || errorr) return <div>{error || errorr}</div>

  return (
    <div className="flex flex-col items-center w-full">
      <div className="flex flex-wrap items-center w-4/5 mt-10 justify-evenly">
        {coaches && CourseTypes &&
          coaches.map((ch, i) => {
            return <CoachesIndex currentCoach={currentCoach} selectedCourse={selectedCourse} setSelectedCourse={(a) => { setSelectedCourse(a); setCurrentCoach(ch._id) }} currentAdmin={currentAdmin} currentCenterId={currentCenterId} currentUser={currentUser} language={language} CourseTypes={CourseTypes} key={i} coache={ch} />;
          })}
      </div>
    </div>
  );
}

const CoachesIndex = ({ coache, currentCoach, currentUser, currentCenterId, selectedCourse, setSelectedCourse, currentAdmin, CourseTypes, language }) => {
  const [print, setPrint] = useState(0);
  CourseTypes && CourseTypes.sort((a, b) => b.iqd - a.iqd || a.price - b.price);
  const componentRef = useRef();
  const [currentCourse, setCurrentCourse] = useState(false);
  const [priceModal, setPriceModal] = useState({
    show: false,
    data: {},
    paymentDetails: {},
    payedType: 0,
    changeType: 1
  })


  const onChangeModal = (pck = {}) => {
    let currentCourse = CourseTypes.find((a) => a._id === selectedCourse);

    setPriceModal(prev => ({ ...prev, show: !prev.show, data: currentCourse }))
  }

  const onChangeModalData = (data) => {
    setPriceModal(data)
  }
  const onSubmit = () => {
    const pD = { ...priceModal.paymentDetails, payedType: priceModal.payedType, changeType: priceModal.changeType }
    // onPrint({ ...priceModal.data, paymentDetails: pD })
    onSelectCourse({ ...priceModal.data, paymentDetails: pD })
    setPriceModal(prev => ({ ...prev, show: false, }))
  }


  const onChangeSelectedCourse = (val) => {
    setPrint(0);
    setSelectedCourse(val);
  };

  const onSelectCourse = async (paymentDetails) => {
    //online or in paper
    onPrint(1, paymentDetails)
  }

  const onPrint = async (type, paymentDetails) => {
    //! type 0 online 1 paper
    if (type === 1)
      setPrint(1);
    let currentCourse = CourseTypes.find((a) => a._id === selectedCourse);
    const trainerRatio = currentCourse.type === 0 ? coache.employment.normalCourseRatio : coache.employment.vipCourseRatio
    const course = {
      adminId: currentAdmin._id,
      centerId: currentCenterId,
      numberId: IDNumberGenerator(6),
      trainerId: coache._id,
      trainerRatio,
      trainerName: coache.name,
      type: currentCourse.type,
      userId: currentUser?._id,
      userName: currentUser?.name,
      courseType: type,
      paymentDetails: paymentDetails.paymentDetails,
    };

    if (currentCourse.iqd) {
      course.iqd = currentCourse.iqd
      course.price = convertCurrency(currentCourse.iqd, 'USD')
    } else {
      course.price = currentCourse.price
      course.iqd = convertCurrency(currentCourse.price, 'IQD')
    };
    setCurrentCourse(course)

    handleLoading();
    await createCourse(course);
    handleLoading();
  };

  const onSelect = () => {
    onSelectCourse()
    // smalltalk
    //   .confirm("", t('Are you sure about executing the action?'))
    //   .then(() => {
    //     onPrint();
    //   })
    //   .catch((e) => {
    //     componentRef.current.close();
    //   });
  };
  // console.log(coache)
  return (
    <div className="flex flex-col items-center justify-center py-2 m-2 border w-80">
      <CoursePriceCalculationModal onSubmit={onSubmit} onChangeModalData={onChangeModalData} priceModal={priceModal} onChangeModal={onChangeModal} />

      <div style={{ display: "none" }}>
        <ComponentToPrint currentUser={currentUser} currentCourse={currentCourse} ref={componentRef} />
      </div>
      <IoPersonCircleSharp color={Colors.whiteCardColor} size={90} />
      <div className="mt-2 text-xl font-bold capitalize opacity-80">
        {coache.name}
      </div>
      <div className="flex flex-row flex-wrap items-center justify-center mt-4">
        {CourseTypes.map((c, i) => {
          return (
            <div
              onClick={onChangeSelectedCourse.bind(this, c._id)}
              className={`cursor-pointer ${selectedCourse === c._id && currentCoach === coache._id
                ? "bg-mainAqwaBlue opacity-100 text-white"
                : "bg-whiteCardColor"
                } p-2 px-4 font-medium opacity-50 m-1`}
              key={i}
            >
              {c.labels[language]} - {c.iqd ? c.iqd : numeral(c.price).format("0.00$")} {c.price ? '- ' + convertCurrency(c.price, 'IQD') : ''}
            </div>
          );
        })}
      </div>
      <div className="flex flex-row flex-wrap items-center w-full mt-4 justify-evenly">
        {print !== 1 && selectedCourse !== 1 && currentCoach === coache._id && <SelectBtn onSelect={onChangeModal} />}
        {print === 1 && (
          <ReactToPrint
            removeAfterPrint
            onPrintError={() => { }}
            trigger={PrintBtn}
            content={() => componentRef.current}
          />
        )}
      </div>
    </div>
  );
};

const ComponentToPrint = React.forwardRef(({ currentUser, currentCourse }, ref) => {
  //!1 2 3
  const imgUri = 'https://i.ibb.co/YLtXBFr/H-HGYM.png'

  return (
    <div style={{}} ref={ref}>
      <div
        style={{
          color: "#292929",
          position: "absolute",
          top: 120,
          right: 30,
          fontFamily: "Montserrat-Bold",
          fontSize: 20,
        }}
      >
        {dayjs().format("DD/MM/YYYY")}
      </div>
      <div
        style={{
          color: "#292929",
          opacity: 0.6,
          position: "absolute",
          left: 25,
          top: 40,
          fontFamily: "Montserrat-Bold",
          fontSize: 17,
        }}
      >
        #{currentCourse.numberId}
      </div>
      <div
        style={{
          color: "#292929",
          opacity: 0.6,
          position: "absolute",
          left: 25,
          top: 60,
          fontFamily: "Montserrat-Bold",
          fontSize: 17,
        }}
      >
        {currentCourse.trainerName}
      </div>
      <img
        style={{ width: "100%", height: "100%", zIndex: 1 }}
        src={imgUri}
      />
      <div className="truncate" style={{
        position: "absolute",
        left: 278,
        top: 122,
        opacity: .9,
        fontFamily: "Montserrat-Bold",
        fontSize: 18,
        width: 200,
      }}>
        : {currentUser.name}
      </div>
    </div>
  );
});

const SelectBtn = ({ onSelect }) => {
  return (
    <div
      className="px-6 py-2 font-bold text-white cursor-pointer bg-mainAqwaBlue opacity-80"
      onClick={onSelect}
    >
      {t('select')}
    </div>
  );
};

const PrintBtn = () => {
  return (
    <div className="px-6 py-2 font-bold text-white cursor-pointer bg-mainAqwaBlue opacity-80">
      {t('print')}
    </div>
  );
};

export default RequestCourseScreen;
